
<template>
    <div class="mainCon">
      <div class="scene-Header">
        <div class="mainDivWidth flexDiv">
          <p class="sceneTitle">SDK支付对接说明</p>
          <div class="bussinbtn" @click="goBusiness()">立即对接</div>
        </div>
      </div>
      <div class="box-shadow">
        <div class="mainDivWidth flexDiv anchorNavList" id="anchorNavList">
          <p v-for="(nl,index) in navList" :key="index" :class=" anchorId == index ? 'nowAnchor' : '' " @click="changeanchorId(index, nl.id)">
            {{nl.text}}
          </p>
        </div>
      </div>
      <section class="mainFun" id="mainFun">
        <div class="mainDivWidth flexDiv feaTure">
          <div class="introduceTextImg">
            <img
              src="static/img/docdescription/mainpic.png"
              class="introduceImg"
            />
            <p>SDK支付对接说明</p>
          </div>
          <div class="first-introduceText">
            <div class="introduceText-Title flexDiv">
              <p class="titleBg">主要功能</p>
              <p class="subheading">MAJOR FUNCTION</p>
            </div>
            <div class="cer-FunCon">
              <p>
                集成佰付美营销平台用户登录系统、支付系统、营销配置和活动配置系统，独创极速出包技术，灵活的可集成架构，快速有效的解决渠道活动配置问题。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="joinFlow" class="payforCont">
        <div class="mainDivWidth">
          <h3 class="sectionTitle whiteText">接入流程</h3>
          <div class="joinCont flexDiv">
            <div class="joinflow"  v-for="(joflow, index) in joinflowList" :key="index">
              <img :src="joflow.joflow" alt="">
              <p v-text="joflow.jointxt"></p>
            </div>
          </div>
        </div>
      </section>
      <section id="sellingPoint">
        <div class="mainDivWidth">
          <h3 class="sectionTitle">接入优势</h3>
          <div class="advantage flexDiv">
            <div class="advantCont" v-for="(spl, index) in sellingPointList" :key="index">
              <img :src="spl.pic" alt="">
              <p v-text="spl.title"></p>
            </div>
          </div>
        </div>
      </section>
      <section class="moreLanguage" id="moreLanguage">
        <h3 class="sectionTitle">多种开发语言支持</h3>
        <div class="flexDiv mainDivWidth devlogo">
            <div class="langumain"  v-for="(lan, index) in languageList" :key="index">
              <img :src="lan.logopic" alt="">
            </div>
        </div>
      </section>
      <section >
        <div class="mainDivWidth">
          <h3 class="sectionTitle pointer hoverBlueText">已接入支付</h3>
          <div class="flexDiv accessPay ">
            <div class="pointer hoverBlueText accesCont">
              <div class="circleradius">
                <img src="static/img/docdescription/iconpic/icon01.png">
              </div>
              <p class="accpaytext">微信支付</p>
            </div>
            <div class="pointer hoverBlueText accesCont">
              <div class="circleradius">
                <img src="static/img/docdescription/iconpic/icon02.png">
              </div>
              <p class="accpaytext">支付宝支付</p>
            </div>
            <div class="pointer hoverBlueText accesCont">
              <div class="circleradius">
                <img src="static/img/docdescription/iconpic/icon03.png">
              </div>
              <p class="accpaytext">银联支付</p>
            </div>
            <div class="pointer hoverBlueText accesCont">
              <div class="circleradius">
                <img src="static/img/docdescription/iconpic/icon04.png">
              </div>
              <p class="accpaytext">云闪付支付</p>
            </div>
            <div class="pointer hoverBlueText accesCont">
                <div class="circleradius">
                  <img src="static/img/docdescription/iconpic/icon05.png">
                </div>
                <p class="accpaytext">各大银行支付</p>
              </div>
          </div>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  export default {
    name: 'dockSdkpay',
    data:function(){
      return {
        anchorId: 0,
        navList: [
          {text: '主要功能', id: 'mainFun'},
          {text: '接入流程', id: 'joinFlow'},
          {text: '接入优势', id: 'sellingPoint'},
          {text: '多种开发语言支持', id: 'moreLanguage'}
        ],
        sellingPointList:[
          {title: '永久免费提供', pic:"static/img/docdescription/icontont/iconfont01.png"},
          {title: '急速出包内核', pic:"static/img/docdescription/icontont/iconfont02.png"},
          {title: '集成架构灵活', pic:"static/img/docdescription/icontont/iconfont03.png"},
          {title: '多种活动配置',pic:"static/img/docdescription/icontont/iconfont04.png"},
          {title: '集成安全稳定',pic:"static/img/docdescription/icontont/iconfont05.png"}
        ],
        languageList:[
          {
            logopic:"static/img/docdescription/SDKpic/languicon/logo01.png"
          },
          {
            logopic:"static/img/docdescription/SDKpic/languicon/logo02.png"
          },
          {
            logopic:"static/img/docdescription/SDKpic/languicon/logo03.png"
          },
          {
            logopic:"static/img/docdescription/SDKpic/languicon/logo04.png"
          },
          {
            logopic:"static/img/docdescription/SDKpic/languicon/logo05.png"
          },
        ],
        joinflowList:[
          {
            joflow:"static/img/docdescription/SDKpic/conneticon/joinicon01.png",
            jointxt:"注册成为佰付美营销平台合作会员"
          },
          {
            joflow:"static/img/docdescription/SDKpic/conneticon/joinicon02.png",
            jointxt:"配置商户信息获取渠道信息"
          },
          {
            joflow:"static/img/docdescription/SDKpic/conneticon/joinicon03.png",
            jointxt:"参数配置"
          },
          {
            joflow:"static/img/docdescription/SDKpic/conneticon/joinicon04.png",
            jointxt:"对接佰付美营销合作SDK"
          },
          {
            joflow:"static/img/docdescription/SDKpic/conneticon/joinicon05.png",
            jointxt:"本地打包，出包测试"
          },
          {
            joflow:"static/img/docdescription/SDKpic/conneticon/joinicon06.png",
            jointxt:"上线"
          },
          {
            joflow:"static/img/docdescription/SDKpic/conneticon/joinicon07.png",
            jointxt:"门户推广"
          }
        ]
      }
    },
    mounted() {
      $("html, body").animate({ scrollTop: "0" }, 0);
    },
    methods:{
      goBusiness(){
        this.$router.push({"path": "/cooperate"})
      },
      changeanchorId(num, id){
        this.anchorId = num;
        $('html, body').animate({scrollTop: $('#'+id).offset().top }, 1000);
        return false;// 返回false可以避免在原链接后加上#
      },
    }
  }
  </script>
  
  <style scoped lang="scss">
    @import "../../assets/css/descriptionClass/docStyle";
    @import "../../assets/css/descriptionClass/SDKsty";
  </style>
  


// WEBPACK FOOTER //
// src/pages/dockingConPage/document2-sdkPay.vue